import React, { Fragment, useState } from "react";
 import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
} from "react-bootstrap";
import {Link, useNavigate} from 'react-router-dom';

 

const examTopper = [
  {id:'111', color:'success', status:'Successful'},
  {id:'112', color:'danger', status:'Canceled'},
  {id:'113', color:'warning', status:'Pending'},
];

const BootstrapTable = (orders) => {
  const [checked, setChecked] = useState(examTopper);
  const [unchecked, setUnChecked] = useState(true);
  const handleChecked = (id)=> {
        let temp = checked.map((data) => {
            if (id === data.id) {
                return { ...data, inputchecked: !data.inputchecked };
            }
            return data;
        });
        setChecked(temp);
    };
    const handleCheckedAll = (value)=> {
        let temp = checked.map((data) => {          
            return { ...data, inputchecked: value };   
        });
        setChecked(temp);
        setUnChecked(!unchecked);
    };

console.log('ccccc',orders)
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  return (
    <Fragment>
         <Row>
        
        <Col lg={12}>
              
              <Card.Body>
              <div className="table-responsive active-projects dlab-scroll task-table my-2 mx-2" style={{  height: "400px" }}>
              <table className="table">
   <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

    <tr>
    <th> الصورة  </th>
    <th>رقم اللوحة</th>
    <th> النوع</th>

<th>الموديل</th>
<th>سنة الصنع</th>
<th>اللون</th>
 
 
    </tr>
  </thead>
  <tbody>
    {orders?.orders?.length > 0 ? (
      orders.orders.map((vehicle, index) => (
        <tr key={index}>
          <td>
            {vehicle.Photo ? (
              <img
                src={`https://subk.education.com.ly/so7ba/public${vehicle.Photo}`}
                alt="Vehicle"
                style={{ width: '50px', height: '50px', objectFit: 'cover' }}
              />
            ) : (
              'No Photo'
            )}
          </td>
          <td>{vehicle.LicensePlate || 'N/A'}</td>
           <td >{vehicle.Make || 'N/A'}</td>
          <td>{vehicle.Model || 'N/A'}</td>
          <td>{vehicle.Year || 'N/A'}</td>
          <td>{vehicle.Color || 'N/A'}</td>
          
          
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="14">لاتوجد سيارات لعرض بياناتها.</td>
      </tr>
    )}
  </tbody>

                </table>
                </div>
              </Card.Body>
           </Col>
         
        </Row>
     </Fragment>
  );
};

export default BootstrapTable;
